import { useCallback, useState } from 'react';
import { useAuth } from '../../../context/auth-context.jsx';
import { adminApi } from '../../../lib/admin-api/index.js';

export function useDownloadSettings() {
  const { token } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const download = useCallback(
    async ({ password, passwordConfirm }) => {
      setIsLoading(true);
      setError('');
      setSuccess('');
      try {
        const response = await adminApi.downloadSettings(token, { password, passwordConfirm });
        const blob = new Blob([response.content], { type: 'application/octet-stream' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = response.filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
        setSuccess('Settings exported successfully.');
      } catch (err) {
        setError(err?.message || 'Export failed.');
      } finally {
        setIsLoading(false);
      }
    },
    [token],
  );

  return { download, isLoading, error, success };
}
